import { Component } from '@angular/core';

@Component({
  selector: 'app-subtree-wrap',
  standalone: true,
  imports: [],
  templateUrl: './subtree-wrap.component.html',
  styleUrl: './subtree-wrap.component.scss'
})
export class SubtreeWrapComponent {

}
